import { combineReducers } from "redux";

import mxalertareducer from "../ducks/components/mxalerta/mxalerta";
import loginreducer from "../ducks/application/login/login";
import updateappreducer from "../ducks/application/updateapp/updateapp";
import vistoriareducer from "../ducks/application/CarregaDescarregaContainer/vistoria";
import avariasreducer from "../ducks/application/CarregaDescarregaContainer/listaAvarias";
import avariasOEAreducer from "../ducks/application/CarregaDescarregaContainer/listaAvariasOEA";
import lacrereducer from "../ducks/application/CarregaDescarregaContainer/lacre";
import detalheISOreducer from "../ducks/application/CarregaDescarregaContainer/detalheISO";
import navigationBarreducer from "../ducks/components/NavigationBar/navigationBar";
import preparaRemocaoReducer from "../ducks/application/remocao/remocao";
import detalheCarregaGateReducer from "../ducks/application/CarregaDescarregaContainer/detalheCarregaGate";
import detalheDescarregaGateReducer from "../ducks/application/CarregaDescarregaContainer/detalheDescarregaGate";
import carregaGateReducer from "../ducks/application/CarregaDescarregaContainer/carregaGate";
import descarregaGateReducer from "../ducks/application/CarregaDescarregaContainer/descarregaGate";
import controleReeferReducer from "../ducks/application/controleReefer/controleReefer";
import detalheGateReducer from "../ducks/application/CarregaDescarregaContainer/detalheGate";
import autorizarEntradaReducer from "../ducks/application/CarregaDescarregaContainer/autorizarEntrada";
import motivoPickupContainerReducer from "../ducks/application/remocao/motivoPickupContainer";
import consultasGeraisReducer from "../ducks/application/ConsultasGerais/consultasGerais";
import armazemGeralReducer from "./application/ArmazemGeral/armazemGeral";
import entrepostoReducer from "./application/Entreposto/entreposto";
import inventarioReducer from "./application/Inventario/inventario";
import carregaDescarregaVolumeMercadoriaReducer from "./application/CarregaDecarregaVolumeMercadoria/carregaDescarregaVolumeMercadoria";
import avariasCargaSoltaReducer from "./application/CarregaDecarregaVolumeMercadoria/listaAvariasCargaSolta";
import solServReducer from "./application/SolServ/SolServ";
import desovaReducer from './application/Desova/desova';
import iniciarDesovaReducer from './application/Desova/iniciarDesova';
import solServDesovaReducer from './application/SolServDesova/solServDesova';
import remocaoVolumeReducer from "./application/RemocaoVolume/RemocaoVolume";
import edicaoVolumesReducer from "./application/EdicaoVolumes/edicaoVolumes";
import operacaoContainerReducer from "./application/OperacaoContainer/OperacaoContainer";
import remontagemVolumeReducer from "./application/RemontagemVolume/RemontagemVolume";
import aplicativoReducer from "./application/Aplicativo/Aplicativo";
import avariaMovimentacaoVolumeReducer from "./application/AvariaMovimentacaoVolume/AvariaMovimentacaoVolume";
import carregamentoPosDescargaReducer from "./application/CarregaDescarregaContainer/carregamentoPosDescarga";
import pesquisaReducer from "./application/pesquisa/pesquisaReducer";
import tipoImagemReducer from "./application/tipoImagem/tipoImagemReducer";
import obterSkillReducer from "./application/ImagensApp/obterSkillReducer";
import oitoPontosOEAReducer from "./application/VistoriaOEA/oitoPontosOEA";
import vistoriaOEAReducer from "./application/VistoriaOEA/vistoriaOEA";
import vistoriaOEAAvariasReducer from "./application/VistoriaOEA/vistoriaOEAAvarias";


const combinedReducers = combineReducers({
    mxalertareducer,
    loginreducer,
    updateappreducer,
    vistoriareducer,
    avariasreducer,
    avariasOEAreducer,
    lacrereducer,
    detalheISOreducer,
    navigationBarreducer,
    preparaRemocaoReducer,
    detalheCarregaGateReducer,
    detalheDescarregaGateReducer,
    carregaGateReducer,
    descarregaGateReducer,
    controleReeferReducer,
    detalheGateReducer,
    autorizarEntradaReducer,
    motivoPickupContainerReducer,
    consultasGeraisReducer,
    armazemGeralReducer,
    entrepostoReducer,
    inventarioReducer,
    carregaDescarregaVolumeMercadoriaReducer,
    avariasCargaSoltaReducer,
    solServReducer,
    desovaReducer,
    iniciarDesovaReducer,
    solServDesovaReducer,
    remocaoVolumeReducer,
    edicaoVolumesReducer,
    operacaoContainerReducer,
    remontagemVolumeReducer,
    aplicativoReducer,
    avariaMovimentacaoVolumeReducer,
    carregamentoPosDescargaReducer,
    pesquisaReducer,
    tipoImagemReducer,
    obterSkillReducer,
    oitoPontosOEAReducer,
    vistoriaOEAReducer,
    vistoriaOEAAvariasReducer
});

const rootReducer = (state, action) => {
    if (action.type === "ROOT/RESET") {
        localStorage.removeItem("persist:root");

        return combinedReducers(
            // @ts-ignore
            /**@type {ReturnType<typeof combineReducers>} */({}),
            action
        );
    }
    return combinedReducers(state, action);
};

export default rootReducer;
